// CTV-840: which of a station's promotions a display ad may advertise.
import type { SelfServicePromotion } from '../../../types/selfService';

/** Active, started, and not yet ended: a promotion a buyer could use today. */
export function promotionIsLive(p: SelfServicePromotion, now: number = Date.now()): boolean {
  if (!p.active) return false;
  if (p.starts_at && new Date(p.starts_at).getTime() > now) return false;
  if (p.ends_at && new Date(p.ends_at).getTime() < now) return false;
  return true;
}
